export enum RoleOption {
  Teacher,
  Admin,
}
